import { getCompanyInfo } from '@/plugins/helpers'

import layoutAdmin from '@/layouts/layoutAdmin.vue';
import cncPurchaseRequisitionView from '@/views/module/purchase/cncRequisitionMerge/cncPurchaseRequisitionView.vue';
import cncRequisitionMerge from '@/views/module/purchase/cncRequisitionMerge/cncRequisitionMerge.vue';
import cncRequisitionMergeRecord from '@/views/module/purchase/cncRequisitionMerge/cncRequisitionMergeRecord.vue';
import csQuotation from '@/views/module/purchase/csQuotation/csQuotation.vue';
import csQuotationRecord from '@/views/module/purchase/csQuotation/csQuotationRecord.vue';
import purchaseOrder from '@/views/module/purchase/purchaseOrder/purchaseOrder.vue';

import purchaseOrderRecord from '@/views/module/purchase/purchaseOrder/purchaseOrderRecord.vue';
import purchaseInvoiceCreate from '@/views/module/purchase/purchaseInvoice/purchaseInvoiceCreate.vue';
import purchaseInvoiceRecord from '@/views/module/purchase/purchaseInvoice/purchaseInvoiceRecord.vue';
import purchaseRequisition from '@/views/module/purchase/purchaseRequisition/purchaseRequisition.vue';
import purchaseRequisitionPending from '@/views/module/purchase/purchaseRequisition/purchaseRequisitionPending.vue';
import purchaseRequisitionRecord from '@/views/module/purchase/purchaseRequisition/purchaseRequisitionRecord.vue';
import purchaseRequisitionView from '@/views/module/purchase/purchaseRequisition/purchaseRequisitionView.vue';
import purchaseRfq from '@/views/module/purchase/purchaseRfq/purchaseRfq.vue';
import purchaseRfqRecord from '@/views/module/purchase/purchaseRfq/purchaseRfqRecord.vue';
import evaluationCriteriaSetup from '@/views/module/purchase/settingManagement/evaluationCriteriaSetup.vue';
import evaluationList from '@/views/module/purchase/settingManagement/evaluationList.vue';
import letterSetup from '@/views/module/purchase/settingManagement/letterSetup.vue';
import evalParamGenerate from '@/views/module/purchase/supplierSelection/evalParamGenerate.vue';
import selectedSupplierList from '@/views/module/purchase/supplierSelection/selectedSupplierList.vue';
import purchaseRequisitionInvoice from '@/views/module/purchase/purchaseRequisition/purchaseRequisitionInvoice.vue';
import cncRequisitionMergeInvoice from '@/views/module/purchase/cncRequisitionMerge/cncRequisitionMergeInvoice.vue';
import purchaseRfqInvoice from '@/views/module/purchase/purchaseRfq/purchaseRfqInvoice.vue';
import csQuotationInvoice from '@/views/module/purchase/csQuotation/csQuotationInvoice.vue';

import viewPurchaseInvoice from '@/views/module/purchase/purchaseInvoice/viewPurchaseInvoice.vue';
import viewPurchaseInvoice_textech from '@/views/module/purchase/purchaseInvoice/viewPurchaseInvoice_textech.vue';

import purSupplierListReport from '@/views/module/purchase/purchaseReports/purSupplierListReport.vue';
import purRequisitionReport from '@/views/module/purchase/purchaseReports/purRequisitionReport.vue';
import purPRApprovalReport from '@/views/module/purchase/purchaseReports/purPRApprovalReport.vue';
import purReqMergeReport from '@/views/module/purchase/purchaseReports/purReqMergeReport.vue';
import purRFQGenReport from '@/views/module/purchase/purchaseReports/purRFQGenReport.vue';
import purCSStateReport from '@/views/module/purchase/purchaseReports/purCSStateReport.vue';
import purCSApprovalReport from '@/views/module/purchase/purchaseReports/purCSApprovalReport.vue';
import purPOOrderReport from '@/views/module/purchase/purchaseReports/purPOOrderReport.vue';
import purPOApprovalReport from '@/views/module/purchase/purchaseReports/purPOApprovalReport.vue';
import purReceiveReport from '@/views/module/purchase/purchaseReports/purReceiveReport.vue';
import supplierPaymentRecord from '@/views/module/purchase/supplierPayment/supplierPaymentRecord.vue';

import purchaseOrderInvoice from '@/views/module/purchase/purchaseOrder/purchaseOrderInvoice.vue';
import purchaseOrderInvoice_textech from '@/views/module/purchase/purchaseOrder/purchaseOrderInvoice_textech.vue';

export default [
    {
      path: '/purchase',
      component: layoutAdmin,
      meta: {
        UserLoggedIn: true,
        breadcrumb: 'Purchase Management',
      },
      children: [
        {
          path: "add-requisition",
          name: "add-requisition",
          meta: {
            breadcrumb: ['Purchase Management','Add Requisition']
          },
          component: purchaseRequisition,
        },
        {
          path: "add-letter-setup",
          name: "add-letter-setup",
          meta: {
            breadcrumb: ['Purchase Management','Add Letter Setup']
          },
          component: letterSetup,
        },
        {
          path: "requisition-record",
          name: "requisition-record",
          meta: {
            breadcrumb: ['Purchase Management','Requisition Record']
          },
          component: purchaseRequisitionRecord,
        },
        {
          path: "view-requisition-invoice",
          name: "view-requisition-invoice",
          meta: {
            breadcrumb: ['Purchase Management','View Requisition Invoice']
          },
          component: purchaseRequisitionInvoice,
        },
        {
          path: "requisition-pending",
          name: "requisition-pending",
          meta: {
            breadcrumb: ['Purchase Management','Purchase Requisition Pending']
          },
          component: purchaseRequisitionPending,
        },
        {
          path: "requisition-view/:id",
          name: "requisition-view",
          meta: {
            breadcrumb: ['Purchase Management','Purchase Requisition View']
          },
          component: purchaseRequisitionView,
        },
        {
          path: "add-rfq",
          name: "add-rfq",
          meta: {
            breadcrumb: ['Purchase Management','Add Rfq']
          },
          component: purchaseRfq,
        },
        {
          path: "rfq-record",
          name: "rfq-record",
          meta: {
            breadcrumb: ['Purchase Management','Rfq Record']
          },
          component: purchaseRfqRecord,
        },
           {
          path: "view-rfq-invoice",
          name: "view-rfq-invoice",
          meta: {
            breadcrumb: ['Purchase Management', 'View RFQ Details']
          },
          component: purchaseRfqInvoice,
        },
        {
          path: "cnc-requisition-merge",
          name: "cnc-requisition-merge",
          meta: {
            breadcrumb: ['Purchase Management','CNC Requisition Merge']
          },
          component: cncRequisitionMerge,
        },
        {
          path: "add-cs-quotation",
          name: "add-cs-quotation",
          meta: {
            breadcrumb: ['Purchase Management','Add Cs Quotation']
          },
          component: csQuotation,
        },
        {
          path: "cs-quotation-record",
          name: "cs-quotation-record",
          meta: {
            breadcrumb: ['Purchase Management','CS Quotation Record']
          },
          component: csQuotationRecord,
        },
        {
          path: "view-cs-quotation-invoice",
          name: "view-cs-quotation-invoice",
          meta: {
            breadcrumb: ['Purchase Management','CS Quotation Invoice']
          },
          component: csQuotationInvoice,
        },
        {
        
          path: "add-purchase/:id?",
          name: "add-purchase",
          meta: {
            breadcrumb: ['Purchase Management','Add Purchase Order']
          },
          component: purchaseOrder,
        },
        {
          path: "invoice-create",
          name: "purchase-invoice-create",
          meta: {
            breadcrumb: ['Purchase Management', 'Invoice Create']
          },
          component: purchaseInvoiceCreate
        },
        {
          path: "invoice-record",
          name: "purchase-invoice-record",
          meta: {
            breadcrumb: ['Purchase Management', 'Invoice Record']
          },
          component: purchaseInvoiceRecord,
        },
        {
          path: "supplier-payment-record",
          name: "supplier-payment-record",
          meta: {
            breadcrumb: ['Purchase Management', 'Supplier Payment Record']
          },
          component: supplierPaymentRecord,
        },
        {
          path: "payment-record",
          name: "payment-record",
          meta: {
            breadcrumb: ['Purchase Management', 'Supplier Payment Record']
          },
          component: supplierPaymentRecord,
        },
        {
          path: "purchase-record",
          name: "purchase-record",
          meta: {
            breadcrumb: ['Purchase Management', 'Purchase Order Record']
          },
          component: purchaseOrderRecord,
        },
        {
          path: "view-purchase-order",
          name: "view-purchase-order",
          meta: {
            breadcrumb: ['Purchase Management', 'View Purchase Order']
          },
          component: () => {
            const companyInfo = getCompanyInfo();
            if (companyInfo.id === 6) {
              return purchaseOrderInvoice_textech;
            }

            return purchaseOrderInvoice
          },
        },

        {
          path: "view-purchase-invoice",
          name: "view-purchase-invoice",
          meta: {
            breadcrumb: ['Purchase Management', 'View Purchase Invoice']
          },
          component: () => {
            const companyInfo = getCompanyInfo();

            if (companyInfo.id === 6) {
              return viewPurchaseInvoice_textech;
            }

            return viewPurchaseInvoice;
          },
        },


        // {
        //   path: "view-purchase-invoice",
        //   name: "view-purchase-invoice",
        //   meta: {
        //     breadcrumb: ['Purchase Management', 'View Purchase Invoice']
        //   },
        //   component: viewPurchaseInvoice,
        // },
        // {
        //   path: "view-purchase-invoice-v2",
        //   name: "view-purchase-invoice-v2",
        //   meta: {
        //     breadcrumb: ['Purchase Management', 'View Purchase Invoice']
        //   },
        //   component: viewPurchaseInvoice_textech,
        // },


        {

          path: "cnc-merge-record",
          name: "cnc-merge-record",
          meta: {
            breadcrumb: ['CNC Requisition Merge Record', 'View Requisition Merge']
          },
          component: cncRequisitionMergeRecord,    
        },
        {

          path: "view-cnc-merge-invoice",
          name: "view-cnc-merge-invoice",
          meta: {
            breadcrumb: ['Purchase', 'CNC Merge Invoice']
          },
          component: cncRequisitionMergeInvoice,    
        },
        {
          path: "cnc-requisition-view/:id",
          name: "cnc-requisition-view",
          meta: {
            breadcrumb: ['CNC Requisition View' , "View CNC Requisition"]
          },
          component: cncPurchaseRequisitionView,
        },
        {
          path: "add-evaluation",
          name: "add-evaluation",
          meta: {
            breadcrumb: ['Purchase Management','Add Evaluation Criteria']
          },
          component: evaluationCriteriaSetup,
        },
        {
          path: "evaluation-list",
          name: "evaluation-list",
          meta: {
            breadcrumb: ['Purchase Management','View Evaluation Criteria']
          },
          component: evaluationList,
        },

        {
          path: "add-eval-param-generate",
          name: "add-eval-param-generate",
          meta: {
            breadcrumb: [ 'Purchase Management', 'Add Eval Param Generate']
          },
          component: evalParamGenerate,
        },
        {
          path: "selected-supplier-list",
          name: "selected-supplier-list",
          meta: {
            breadcrumb: [ 'Purchase Management' , 'Selected Suppiler List' ]
          },
          component: selectedSupplierList,
        },
        {
          path: "supplier-list-report",
          name: "supplier-list-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'Suppiler List Report' ]
          },
          component: purSupplierListReport,
        },
        {
          path: "requisition-report",
          name: "requisition-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'Requisition Report' ]
          },
          component: purRequisitionReport,
        },
        {
          path: "prapproval-report",
          name: "prapproval-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'PR Approval Report' ]
          },
          component: purPRApprovalReport,
        },
        {
          path: "reqmerge-report",
          name: "reqmerge-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'CNC Merge Report' ]
          },
          component: purReqMergeReport,
        },
        {
          path: "rfqgen-report",
          name: "rfqgen-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'RFQ Generation Report' ]
          },
          component: purRFQGenReport,
        },
        {
          path: "csstate-report",
          name: "csstate-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'Comparative Statement Report' ]
          },
          component: purCSStateReport,
        },
        {
          path: "csapproval-report",
          name: "csapproval-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'CS Approval Report' ]
          },
          component: purCSApprovalReport,
        },
        {
          path: "poorder-report",
          name: "poorder-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'Purchase Order Report' ]
          },
          component: purPOOrderReport,
        },
        {
          path: "poapproval-report",
          name: "poapproval-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'PO Approval Report' ]
          },
          component: purPOApprovalReport,
        },
        {
          path: "receive-report",
          name: "receive-report",
          meta: {
            breadcrumb: [ 'Purchase Reports' , 'Purchase Receive Report' ]
          },
          component: purReceiveReport,
        },
        
      ],
      
    },
    
  ]


  